export default "__VITE_ASSET__BSrQLrMG__"